import React from 'react';

import {
  Box,
  IconButton
} from '@mui/material';
import {
  NetSuiteRecordChip,
  routeDirectory
} from 'modules';

import { ChevronRight } from '@mui/icons-material';
import { Table } from 'iron-forge-react-modules';
import * as types from './types';
import * as sharedTypes from '../types';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export interface IProps {
  returnAuthorizations: sharedTypes.IReturnAuthorization[];
}

export const FC: React.FC<IProps> = props => {
  const rows = React.useMemo(
    () => props.returnAuthorizations.map((returnAuthorization): Table.IRow<types.IColumnId> => ({
      id: returnAuthorization.id,
      columnId2Value: {
        transactionId: {
          type: 'string',
          label: returnAuthorization.netSuiteTransactionId
        },
        preAlertDate: {
          type: 'string',
          sortableValue: '',
          label: returnAuthorization.preAlertDate.toFormat('MM/dd/yyyy')
        },
        referenceNumber: {
          type: 'string',
          sortableValue: '',
          label: returnAuthorization.referenceNumber
        },
        netSuiteRecord: {
          type: 'component',
          sortableValue: '',
          label: <NetSuiteRecordChip.FC writeStatus={returnAuthorization.netSuiteRecord} />
        },
        itemName: {
          type: 'string',
          label: returnAuthorization.itemName
        },
        itemSku: {
          type: 'string',
          label: returnAuthorization.itemSku
        },
        storeName: {
          type: 'string',
          label: returnAuthorization.storeName
        },
        expectedSerialNumber: {
          type: 'string',
          label: returnAuthorization.expectedSerialNumber
        },
        goTo: {
          type: 'component',
          sortableValue: '',
          label: (
            <IconButton
              href={routeDirectory.admin.tier1ReturnAuthorizations.detail.path(returnAuthorization.id)}
              target="_blank">
              <ChevronRight />
            </IconButton>
          )
        }
      }
    })),
    [props.returnAuthorizations]
  );

  return (
    <Box sx={{ ml: 7 }}>
      <TableComponent
        rows={rows}
        columns={[
          {
            id: 'preAlertDate',
            label: "Pre-Alert Date"
          },
          {
            id: 'transactionId',
            label: "RMA Number"
          },
          {
            id: 'referenceNumber',
            label: "Reference Number"
          },
          {
            id: 'expectedSerialNumber',
            label: "IMEI"
          },
          {
            id: 'itemSku',
            label: "SKU"
          },
          {
            id: 'itemName',
            label: "Model"
          },
          {
            id: 'storeName',
            label: "T1 Client"
          },
          {
            id: 'netSuiteRecord',
            label: "NS Write Status"
          },
          {
            id: 'goTo',
            label: ""
          }
        ]} />
    </Box>
  );
};
